// Generates 15-minute interval slots for the time grid.
import { useMemo } from 'react';

import { CALENDAR_START_HOUR, CALENDAR_END_HOUR } from '@/config/constants';

const useTimeSlots = (
  startHour = CALENDAR_START_HOUR,
  endHour = CALENDAR_END_HOUR,
) => {
  const fifteenMinuteSlots = useMemo(() => {
    const slots = [];
    // Start from the beginning of the startHour
    const startTimeInMinutes = startHour * 60;
    // End at the beginning of the endHour
    const endTimeInMinutes = endHour * 60;
    const interval = 15; // 15-minute interval

    for (
      let totalMinutes = startTimeInMinutes;
      totalMinutes < endTimeInMinutes;
      totalMinutes += interval
    ) {
      const hour = Math.floor(totalMinutes / 60);
      const minute = totalMinutes % 60;
      slots.push(
        `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`,
      );
    }
    return slots;
  }, [startHour, endHour]);

  return fifteenMinuteSlots;
};

export default useTimeSlots;
